import React, { useRef } from 'react';

interface SwipeableDivProps {
  onSwipeLeft?: () => void;
  onSwipeRight?: () => void;
  children: React.ReactNode;
  className?: string;
  threshold?: number; // ngưỡng px để tính là vuốt (mặc định 50)
}

const SwipeableDiv: React.FC<SwipeableDivProps> = ({
  onSwipeLeft,
  onSwipeRight,
  children,
  className = '',
  threshold = 50,
}) => {
  const touchStartX = useRef<number | null>(null);

  const handlePointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    // Chỉ lấy touch/mouse chính (primary)
    if (e.isPrimary) {
      touchStartX.current = e.clientX;
    }
  };

  const handlePointerUp = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!e.isPrimary || touchStartX.current === null) return;

    const touchEndX = e.clientX;
    const deltaX = touchEndX - touchStartX.current;

    // Chỉ xử lý nếu vuốt ngang đủ xa (tránh nhầm với click)
    if (Math.abs(deltaX) > threshold) {
      if (deltaX > 0) {
        onSwipeRight?.(); // vuốt sang phải
      } else {
        onSwipeLeft?.();  // vuốt sang trái
      }
    }

    touchStartX.current = null;
  };

  // Optional: hủy nếu di chuyển ra ngoài (tốt hơn UX)
  const handlePointerCancel = () => {
    touchStartX.current = null;
  };

  return (
    <div
      className={`select-none touch-none ${className}`}
      onPointerDown={handlePointerDown}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerCancel}
      // Để hỗ trợ tốt hơn trên mobile:
      style={{ touchAction: 'pan-y' }} // cho phép scroll dọc, chặn ngang để mình xử lý
    >
      {children}
    </div>
  );
};

export default SwipeableDiv;